import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useHistory, useRouteMatch } from 'react-router-dom';

const ViewDetailCell = ({ invoiceId }) => {
  const history = useHistory();
  const { url } = useRouteMatch();

  return (
    <Button
      variant="secondary"
      color="primary"
      size="small_1"
      onClick={() => history.push(`${url}/${invoiceId}`)}
      id={`view-detail-${invoiceId}`}
      endIcon={<ChevronRightIcon />}
      sx={{
        fontWeight: 700,
        borderRadius: '100px',
        whiteSpace: 'nowrap',
        justifyContent: 'center',
        '& .MuiButton-endIcon': { ml: 0.25 },
      }}
    >
      Ver detalle
    </Button>
  );
};

ViewDetailCell.propTypes = {
  invoiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ViewDetailCell;
